import React, { useContext, useEffect, useReducer, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Collapse } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MenuList } from "./Menu";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = ({ currentUserRole, role_permissions }) => {
  let date = new Date();
  const { iconHover, sidebarposition, headerposition, sidebarLayout, ChangeIconSidebar } = useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);

  useEffect(() => {
    const currentPage = window.location.pathname;

    console.log('cuurent', currentPage)
    switch (currentPage) {
      case "/dashboard":
        handleMenuActive("Dashboard");
        break;
      case "/users":
        handleMenuActive("Users");
        break;
      case "/roles":
        handleMenuActive("Roles");
        break;
      case "/customers":
        handleMenuActive("Customers");
        break;
      case "/transactions":
        handleMenuActive("Transactions");
      case "/inStoreRedeem":
        handleMenuActive("redeem_requests");
        break;
    }
  }, []);

  let handleheartBlast = document.querySelector(".heart");
  function heartBlast() {
    return handleheartBlast.classList.toggle("heart-blast");
  }

  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (status === "Transactions" || status === "Reports" || status === "Settings") {
      if (state.active === status) {
        setState({ active: "" });
      }
    }
  };

  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };

  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  return (
    <div onMouseEnter={() => ChangeIconSidebar(true)} onMouseLeave={() => ChangeIconSidebar(false)} className={`deznav border-right ${iconHover} ${sidebarposition.value === "fixed" && sidebarLayout.value === "horizontal" && headerposition.value === "static" ? (hideOnScroll > 120 ? "fixed" : "") : ""}`}>
      <PerfectScrollbar className='deznav-scroll'>
        <ul className='metismenu' id='menu'>
          {/* {MenuList.filter((item) => item.roles.includes(currentUserRole)).map((data, index) => {
            let menuClass = data.classsChange;
            if (menuClass === "menu-title") {
              return (
                <li className={menuClass} key={index}>
                  {data.title}
                </li>
              );
            } else {
              return (
                <li className={` ${state.active === data.title ? "mm-active" : ""}`} key={index}>
                  {data.content && data.content.length > 0 ? (
                    <Link
                      to={"#"}
                      className='has-arrow'
                      onClick={() => {
                        handleMenuActive(data.title);
                      }}
                    >
                      {state.active === data.title ? data.iconStyleActive : data.iconStyle}{" "}
                      <span className='nav-text'>
                        {data.title}
                        {data.update && data.update.length > 0 ? <span className='badge badge-xs badge-danger ms-2'>{data.update}</span> : ""}
                      </span>
                    </Link>
                  ) : (
                    <Link
                      to={data.to}
                      onClick={() => {
                        handleMenuActive(data.title);
                      }}
                    >
                      {state.active === data.title ? data.iconStyleActive : data.iconStyle}{" "}
                      <span className='nav-text'>
                        {data.title}
                        {data.update && data.update.length > 0 ? <span className='badge badge-xs badge-danger ms-2'>{data.update}</span> : ""}
                      </span>
                    </Link>
                  )}
                  <Collapse in={state.active === data.title && data.content && data.content.length > 0 ? true : false}>
                    <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`} style={data.content && data.content.length > 0 ? {} : { display: "none" }}>
                      {data.content &&
                        data.content.map((data, index) => {
                          return (
                            <li key={index} className={`${state.activeSubmenu === data.title ? "mm-active" : ""}`}>
                              {data.content && data.content.length > 0 ? (
                                <>
                                  <Link
                                    to={data.to}
                                    className={data.hasMenu ? "has-arrow" : ""}
                                    onClick={() => {
                                      handleSubmenuActive(data.title);
                                    }}
                                  >
                                    {data.title}
                                  </Link>
                                  <Collapse in={state.activeSubmenu === data.title ? true : false}>
                                    <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                                      {data.content &&
                                        data.content.map((data, index) => {
                                          return (
                                            <li key={index}>
                                              <Link className={`${path === data.to ? "mm-active" : ""}`} to={data.to}>
                                                {data.title}
                                              </Link>
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </Collapse>
                                </>
                              ) : (
                                <Link to={data.to}>{data.title}</Link>
                              )}
                            </li>
                          );
                        })}
                    </ul>
                  </Collapse>
                </li>
              );
            }
          })} */}
          {console.log('checking roles', role_permissions)}
          {MenuList.filter((item) => role_permissions[item.moduleName] === true || item.moduleName == "dashboard").map((data, index) => {
            let menuClass = data.classsChange;
            if (menuClass === "menu-title") {
              return (
                <li className={menuClass} key={index}>
                  {data.title}
                </li>
              );
            } else {
              return (
                <li className={` ${state.active === data.title ? "mm-active" : ""}`} key={index}>
                  {data.content && data.content.length > 0 ? (
                    <Link
                      to={"#"}
                      className='has-arrow'
                      onClick={() => {
                        handleMenuActive(data.title);
                      }}
                    >
                      {state.active === data.title ? data.iconStyleActive : data.iconStyle}{" "}
                      <span className='nav-text'>
                        {data.title}
                        {data.update && data.update.length > 0 ? <span className='badge badge-xs badge-danger ms-2'>{data.update}</span> : ""}
                      </span>
                    </Link>
                  ) : (
                    <Link
                      to={data.to}
                      onClick={() => {
                        handleMenuActive(data.title);
                      }}
                    >
                      {state.active === data.title ? data.iconStyleActive : data.iconStyle}{" "}
                      <span className='nav-text'>
                        {data.title}
                        {data.update && data.update.length > 0 ? <span className='badge badge-xs badge-danger ms-2'>{data.update}</span> : ""}
                      </span>
                    </Link>
                  )}
                  <Collapse in={state.active === data.title && data.content && data.content.length > 0 ? true : false}>
                    <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`} style={data.content && data.content.length > 0 ? {} : { display: "none" }}>
                      {data.content &&
                        data.content.map((subItem, subIndex) => (
                          <li key={subIndex} className={`${state.activeSubmenu === subItem.title ? "mm-active" : ""}`}>
                            {subItem.content && subItem.content.length > 0 ? (
                              <>
                                <Link
                                  to={subItem.to}
                                  className={subItem.hasMenu ? "has-arrow" : ""}
                                  onClick={() => {
                                    handleSubmenuActive(subItem.title);
                                  }}
                                >
                                  {subItem.title}
                                </Link>
                                <Collapse in={state.activeSubmenu === subItem.title ? true : false}>
                                  <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                                    {subItem.content &&
                                      subItem.content.map((subSubItem, subSubIndex) => (
                                        <li key={subSubIndex}>
                                          <Link className={`${path === subSubItem.to ? "mm-active" : ""}`} to={subSubItem.to}>
                                            {subSubItem.title}
                                          </Link>
                                        </li>
                                      ))}
                                  </ul>
                                </Collapse>
                              </>
                            ) : (
                              <Link to={subItem.to}>{subItem.title}</Link>
                            )}
                          </li>
                        ))}
                    </ul>
                  </Collapse>
                </li>
              );
            }
          })}
        </ul>
        <div className='copyright'>
          <p className='fs-13 font-w200'>
            <strong className='font-w400'></strong>DhanGold © {date.getFullYear()} All Rights Reserved
          </p>
          <p>
            {" "}
            Version <strong className='font-w800'>{process.env.REACT_APP_VERSION}</strong>
          </p>
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
